<template>
    <div class="pay-container">
        <!--轮播图区域-->
        <div class="pay-img">
            <img :src="bgImageUrl">
            <!--<img src="/Themes/Rccl.NewTheme/image/success1.jpg" alt="" />-->
            <!--二维码区域-->
            <div class="pay-code">
                <div class="pay-top">
                    <div class="pay-title">
                        <img class="f-fl" src="https://resource.rcclchina.com.cn/paySuccess/gou.jpg">
                        <div class="succ f-fr">
                            <span>支付成功</span>
                            <span>美好旅程即将开启</span>
                        </div>
                    </div>
                    <div class="pay-ma f-fr">
                        <div id="qrcode">
                            <img :src="qrCodeUrl" class="qrCodeImage" style="display: block;">
                        </div>
                        <img src="https://resource.rcclchina.com.cn/logo/logo.jpg" class="qrCodeLogo">
                        <div class="qrcode-text">扫码分享全程</div>
                    </div>
                </div>
                <div class="pay-center">
                    <div class="pay-step">


                        <div class="pay-parah">
                            1.支付成功后，将需要3个工作日左右对您的订单进行确认及系统操作，订单确认后，请务必在开航7天之前办理在线值船，打印“登船证”并于登船当天携带。如遇紧急情况，请您拨打皇家客服专线：400-820-7195
                            。
                        </div>
                        <div class="pay-parah">
                            2.码头办理登船时间为登船当日 {{pageData.boardingTime}}，请您务必于该时间段内抵达码头办理登船，否则将影响您的出行。每个航次的具体登船时间请以行前短信通知为准。
                        </div>
                        <div class="pay-parah" style="display:flex">
                            <div>3.码头地址：</div>
                            <div v-html="pageData.portAddress">
                            </div>
                        </div>
                    </div>
                    <div class="pay-btn">
                        <router-link to="/Rccl.UserCenter/OrderRecord/List">订到超棒旅程，瞄一眼火热订单！</router-link>
                    </div>
                </div>
            </div>
        </div>
<!--      问卷调查-->
      <div v-if="info" class="survey-question-main">
        <div class="main">
          <questionnaire :infoList="info"
                         :isShowTitleNumber="true"
                         :submitStyle="false"
                         :isPaySuccess="true"
                         :bookingRdId="-1"
                         :orderId="orderId"
          ></questionnaire>
        </div>
      </div>

        <div class="pay-shore">
            <!--左侧 预定皇家岸上观光的三大理由-->
            <div class="shore-content">
                <div class="shore-reason">
                    <img src="https://resource.rcclchina.com.cn/shorex/shorex-title.png" alt="Alternate Text"
                        style="width: 100%;">
                    <div class="shore-title" v-if="payShorexes.length > 0">请在线升级付费精品游套餐</div>
                    <div class="good-products" v-if="payShorexes.length > 0">
                        <ul>
                            <li v-for="(cruise, i) in cruises" :key="('cruise_'+i)">
                                <div class="order-title">{{cruise.cruiseName}}</div>
                                <div v-for="(shorex) in cruise.shorexes" :key="('shorex_'+shorex.id)">
                                    <div class="price-title">
                                        <span class="title-1">{{shorex.shorexName}}</span>
                                        <span class="title-2">价格:${{shorex.price}}/每人 (上船自动房卡扣款)</span>
                                    </div>
                                    <div class="order-intro" v-for="(tour, j) in shorex.shorexTours" :key="('shorex_'+shorex.id+'_tour_'+j)">
                                        <div class="shorex-trip-image">
                                            <img :src="tour.image" alt="">
                                        </div>
                                        <div class="order-explain">
                                            <div class="ex-title">{{tour.shorexName}} - {{tour.duration}}</div>
                                            <div class="order-parah" v-html="tour.shorexDescription">

                                            </div>
                                        </div>
                                    </div>
                                    <div class="up-order">请选择需要升级的订单</div>
                                    <div class="order-info">
                                        <ShorexBookingItem
                                            v-for="(booking) in getBookingByCruise(cruise.shipCode, cruise.sailDate)"
                                            :key="('shorex_'+shorex.id+'_booking_') + booking.bookingId"
                                            :booking="booking"
                                            :shorex="shorex"
                                            :isSelected="isBookingChecked(shorex.id, booking.id)"
                                            :onShorexBookingSelected="onShorexBookingSelected"
                                            />
                                    </div>
                                </div>

                                <div class="order-notice">
                                    <div class="notice">注:</div>
                                    <div class="tiny">
                                        <div><span class="parah-num">1)</span>目的地的产品及行程仅供参考，实际行程以具体航次和地接社安排为准。</div>
                                        <div><span class="parah-num">2)</span>目的地产品及行程可能因相关政府政策及/或保护公共健康安全之相关要求而取消、变更或调整。</div>
<!--                                        <div><span class="parah-num">3)</span>关于岸上观光产品的咨询、预订和修改，您可以拨打400-820-3187和皇家加勒比游轮度假专家联系。</div>-->
                                    </div>
                                </div>

                            </li>
                        </ul>
                    </div>
                    <div class="unShorex-css" v-else>
                        <div>很抱歉，该航次岸上观光服务尚未开放选定，选定开放后，我们会在第一时间以短信的方式通知您，您也可以密切关注皇家加勒比官方网站。</div>
                    </div>
                </div>
            </div>

            <ShorexSummary
            :selectedShorexes="selectedShorexes"
            :shorexes="payShorexes"/>

        </div>

        <!--更多目的地风光-->
        <div class="shore-img">
            <a @click="goToPcp">
                <img src="https://resource.rcclchina.com.cn/logo/pcp-banner.jpg" alt="" style="width: 100%;">
            </a>
        </div>

    </div>
</template>

<script>
import api from '@/api'
import qrcode from 'qrcode'
import Questionnaire from "@/components/Questionnaire/Questionnaire.vue";
const ShorexSummary = () => import('@/components/Booking/PaySuccess/ShorexSummary')
const ShorexBookingItem = () => import('@/components/Booking/PaySuccess/ShorexBookingItem')
export default {
    name: "PaySuccess",
    components: {
      Questionnaire,
        ShorexSummary,
        ShorexBookingItem
    },
    data () {
        return {
            isSuccess: false,
            pageData: {},
            qrCodeUrl: "",
            bgImageUrl: "",
            selectedShorexes: [],
            type: '',
            info: null,
            titleCenter: false,
            orderId: '',
        }
    },
    beforeMount () {
        this.initPage()
      let query = this.$route.query;
      this.type = query.type || 'HOME';
      this.getQuestions();
      this.orderId = query.orderId || ''
    },
    beforeDestroy () {

    },
    methods: {
        async initPage() {
            const userToken = this.$store.state.user.userToken
            if (!userToken || userToken == '') {
                this.$router.push({ name: 'Login', query:{
                    returnUrl: location.href
                }})
                return
            }
            const query = this.$router.currentRoute.query
            if ((!query.payMentId || query.payMentId == '') && !query.paymentId || query.paymentId == '') {
                // return this.$router.push({
                //     name: "BookingListPage"
                // })
            }
            let paymentId = query.payMentId
            if (!paymentId || paymentId == '') {
                paymentId = query.paymentId
            }
            const { success, data, errMsg } = await api.booking.paySuccess({
                paymentId: paymentId,
                userName: userToken
            })
            if (!success) {
                console.error(errMsg)
                // return this.$router.push({
                //     name: "BookingListPage"
                // })
            }
            this.pageData = this.initBookingData(data)
            this.isSuccess = true
            if (data.apiBookings.length > 0) {
                const booking = data.apiBookings[0]
                const url = `${process.env.VUE_APP_BASE_URL}/Rccl.Cruise/CruiseDetail?shipCode=${booking.shipCode}&sailDate=${booking.sailDate}`
                this.qrCodeUrl = await qrcode.toDataURL(url)
                switch (booking.shipCode) {
                    case "SC": this.bgImageUrl = "https://resource.rcclchina.com.cn/Ship/PaySuccess/SC.jpg"; break;
                    case "QN": this.bgImageUrl = "https://resource.rcclchina.com.cn/Ship/PaySuccess/QN.jpg"; break;
                    case "VY": this.bgImageUrl = "https://resource.rcclchina.com.cn/Ship/PaySuccess/VY.jpg"; break;
                    default: this.bgImageUrl = "https://resource.rcclchina.com.cn/Ship/PaySuccess/SC.jpg"; break;
                }

            }
        },
        // 预处理接口返回数据，把bookingcruise放到booking里面
        initBookingData (data) {
            if (data.apiBookings && data.bookingCruises) {
                data.apiBookings.forEach((booking) => {
                    const cruise = data.bookingCruises.find(r=>r.cruiseId == booking.cruisePartRecord_Id)
                    booking.cruise = cruise
                })
            }
            return data
        },
        getSelectBookingsByShorexId(shorexId) {
            const selectedShorex = this.selectedShorexes.find(r=>r.shorex.id == shorexId)
            if (!selectedShorex) return []
            return selectedShorex.bookings
        },
        isBookingChecked (shorexId, bookingRecordId) {
            const selectedBookings = this.getSelectBookingsByShorexId(shorexId)
            return selectedBookings.some(r=>r.id == bookingRecordId)
        },
        getCruise (shipCode, sailDate) {
            return this.bookingCruises.find(r=>r.shipCode == shipCode && r.sailDate == sailDate)
        },
        getBookingByCruise (shipCode, sailDate) {
            return this.bookings.filter(r=>r.shipCode == shipCode && r.sailDate == sailDate)
        },
        onShorexBookingSelected (isChecked, shorex, booking) {
            let selectedShorex = this.selectedShorexes.find(r=>r.shorex.id == shorex.id)
            if (!isChecked) {
                // 反选
                if (selectedShorex && selectedShorex.bookings) {
                    selectedShorex.bookings = selectedShorex.bookings.filter(r=>r.id != booking.id)
                }
            } else {
                if (!selectedShorex) {
                    selectedShorex = {
                        shorex,
                        bookings: [booking]
                    }
                    this.selectedShorexes.push(selectedShorex)
                } else {
                    if (!selectedShorex.bookings.some(r=>r.id == booking.id)) {
                        selectedShorex.bookings.push(booking)
                    }
                }

                // 岸上观光每张订单只能选一个，如果选了其他的话，需要把其他的删掉
                const otherShorexes = this.selectedShorexes.filter(r=>r.shorex.id != shorex.id)
                otherShorexes.forEach(otherShorex => {
                    if (otherShorex.bookings && otherShorex.bookings.some(r=>r.id == booking.id)) {
                        otherShorex.bookings = otherShorex.bookings.filter(r=>r.id != booking.id)
                    }
                })
            }

            // 全部处理完之后，查找如果selected shorex里面的bookings是空的，需要去掉
            const needDelete = this.selectedShorexes.filter(r=>!r.bookings || r.bookings.length == 0)
            .map(r=>r.shorex.id)
            this.selectedShorexes = this.selectedShorexes.filter(r=> needDelete.indexOf(r.shorex.id)<0)
        },
        async goToPcp () {
            const { data } = await api.user.getPcpToken()
            let token = ""
            if (data && data.length > 0) {
                token = data
            }
            let url = `${process.env.VUE_APP_PCP_URL}/Rccl.Pcp/Home/Index?token=${token}`
            if (this.firstBooking) {
                url += `&sailDate=${this.firstBooking.sailDate}&shipCode=${this.firstBooking.shipCode}&bookingId=${this.firstBooking.bookingId}`
            }
            location.href = url
        },
      async getQuestions() {
        this.$loading.show()
        const {success, data, errMsg} = await api.questionnaire.getCampaignQuestions({
          type: this.type
        })
        this.$loading.hide()
        if(success) {
          console.log(data);
          let { campaignSurveyPageTitle } = data;
          this.info = this.surveyFormat(data,null);
          this.$store.commit('SET_PAGE_TITLE', campaignSurveyPageTitle)
        } else {
          this.$alert.show(errMsg)
        }
      },
      // 数据处理
      surveyFormat(rows, type, defaultVal){
        let customTypeIcon = {
          "Booking": "liucheng.png",
          "ImportantInfo": "info-1.png",
          "CustomerService": "custom-service.png"
        }
        rows.categoryQuestionItems && rows.categoryQuestionItems.forEach((row,idx)=> {
          if(rows.categoryQuestionItems[0].questionItems[0].customType === "Point") {
            row.show = idx === 0;
          } else {
            row.show = true;
          }
          row.questionItems && row.questionItems.forEach((qtItem)=> {
            qtItem.value = qtItem.type === 4 ? defaultVal : null;
            qtItem.isFocus = false;
            qtItem.icon = customTypeIcon[qtItem.customType]
            if(qtItem.type === 4) {
              let indexList = [];
              for (let i = 1; i <= 10; i++) {
                indexList.push({
                  text: i,
                  selectClass: ""
                })
              }
              qtItem.indexList = indexList;
            }
            qtItem.optionItems && qtItem.optionItems.forEach((option)=> {
              option.checked = false;
              option.otherVal = "";
              option.isOther = option.optionName === "其他" || option.optionName === "其它"
            })
          })
          row.NO = (idx+1) > 9 ? (idx+1) : `0${idx+1}`
        });
        console.log(rows)
        return rows;
      }
    },
    computed: {
        bookings () {
            return this.pageData.apiBookings || []
        },
        firstBooking () {
            return this.bookings.length > 0 ? this.bookings[0]: null
        },
        bookingCruises () {
            return this.pageData.bookingCruises || []
        },
        freeShorexes() {
            return this.pageData.freeShorexList || []
        },
        payShorexes () {
            return this.pageData.shorexList || []
        },
        hasShorexes () {
            return this.freeShorexes.length > 0 || this.payShorexes.length > 0
        },
        selectedFreeShorex () {
            const shorexIds = this.bookings.filter(r=>r.shorexPartRecord_Id && r.shorexPartRecord_Id > 0)
            .map(r=>r.shorexPartRecord_Id)
            if (shorexIds.length == 0) {
                return {}
            }
            const freeShorex = this.freeShorexes.find(r=>shorexIds.indexOf(r.id) >= 0)
            return freeShorex
        },
        cruises () {
            let cruises = []
            this.payShorexes.forEach((shorex) => {
                const shipCode = shorex.ship
                const sailDate = shorex.sailDate.substring(0, 10)
                let cruise = cruises.find(r=>r.shipCode == shipCode && r.sailDate == sailDate)
                if (!cruise) {
                    cruise = {
                        shipCode,
                        sailDate,
                        shorexes: [shorex]
                    }
                    const bookingCruise = this.bookingCruises.find(r=>r.shipCode == shipCode && r.sailDate == sailDate)
                    if (bookingCruise && bookingCruise.cruiseName) {
                        cruise.cruiseName = bookingCruise.cruiseName
                    }
                    cruises.push(cruise)
                } else {
                    cruise.shorexes.push(shorex)
                }
            })
            return cruises
        }
    }



}
</script>

<style lang="less" scoped>
.pay-container {
    width: 100%;
    height: 100%;
    background: #f3f6f8;
    padding-bottom: 225px;
    a:hover, a:link, a:active, a:visited {
        color: #333;
        text-decoration: none;
    }
    .pay-img {
        width: 1200px;
        height: 521px;
        margin: 0 auto;
        overflow: hidden;
        position: relative;
        //margin-bottom: 58px;
        .pay-code {
            width: 472px;
            position: absolute;
            background: #fff;
            left: 68px;
            top: 46px;
            border-radius: 9px;
            padding: 20px 30px 0;
            .pay-top {
                display: flex;
                justify-content: space-around;
            }
            .pay-title img {
                position: relative;
                top: 12px;
                margin-right: 8px;
            }
            .pay-title .succ span {
                display: block;
                margin-top: 4px;
                font-weight: bold;
                font-size: 22px;
                color: #282b2c;
            }
            .pay-ma {
                position: relative;
                .qrCodeImage {
                    width: 90px;
                }
                .qrCodeLogo {
                    position: absolute;
                    width: 25px;
                    top: 32px;
                    left: 32px;
                }
                .qrcode-text {
                    position: relative;
                    top: -8px;
                    left: 3px;
                }
            }
            .pay-center {
                position: relative;
                margin-top: -5px;
            }
            .pay-step {
                width: 386px;
                font-size: 14px;
                line-height: 26px;
            }
            .pay-btn {
                width: 400px;
                height: 54px;
                line-height: 54px;
                background: #ffd800;
                color: #282b2c;
                text-align: center;
                font-weight: 400;
                margin: 20px auto;
                cursor: pointer;
                font-size: 18px;
            }
        }
    }

    .pay-shore {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        position: relative;
        margin-top: 30px;
        .shore-content {
            width: 884px;
            background: #fff;
            padding: 40px 20px 0px 20px;
            .shore-title {
                color: #006ab9;
                font-size: 20px;
                font-weight: bold;
                margin-bottom: 20px;
            }
            .parah-num {
                display: inline-block;
                width: 20px;
            }
            .good-products {
                ul li {
                    padding-bottom: 30px;
                    .order-title {
                        background: #006ab9;
                        height: 40px;
                        line-height: 40px;
                        text-align: center;
                        color: #fff;
                        font-size: 20px;
                        font-weight: bold;
                        margin-bottom: 30px;
                    }
                    .price-title {
                        display: flex;
                        .title-1 {
                            font-size: 20px;
                            font-weight: 400;
                            color: #282b2c;
                            display: inline-block;
                            width: 277px;
                        }
                        .title-2 {
                            color: #041455;
                            font-size: 20px;
                            font-weight: 400;
                        }
                    }
                    .order-intro {
                        display: block;
                        margin-top: 12px;
                        .shorex-trip-image {
                            width: 250px;
                            display: inline-block;
                            vertical-align: top;
                            img {
                                width: 100%;
                            }
                        }
                        .order-explain {
                            margin-left: 28px;
                            display: inline-block;
                            vertical-align: top;
                            width: 560px;
                            .ex-title {
                                font-weight: 400;
                                font-size: 15px;
                                color: #282b2c;
                                margin-bottom: 8px;
                            }
                            .order-parah {
                                line-height: 20px;
                                font-size: 14px;
                                color: #5a5a5a;
                                font-weight: 400;
                            }
                        }

                    }
                    .up-order {
                        height: 28px;
                        line-height: 28px;
                        background: #f3f6f8;
                        text-align: center;
                        margin: 14px 0 24px 0;
                        border-radius: 8px;
                        font-weight: 400;
                        color: #747d80;
                    }
                    .order-info {
                        overflow: hidden;
                        margin-bottom: 30px;
                        padding-bottom: 30px;
                        border-bottom: solid 1px #ddd;

                    }
                    .order-notice {
                        display: flex;
                        margin-top: 20px;
                        color: #747d80;
                        font-weight: 500;
                        .notice {
                            margin-right: 12px;
                        }
                    }
                }
            }
        }
    }

    .unShorex-css {
        display: flex;
        margin-top: 20px;
        color: #747d80;
        font-weight: 500;
        padding: 0 10px;
        text-align: center;
    }

    .shore-img {
        width: 1200px;
        margin: 12px auto;
    }
}
</style>
